import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "row mb-4" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "row mb-4" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mt-25" }
const _hoisted_16 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createVNode(_component_router_link, {
              to: "/ventes/liste-ventes",
              class: "btn btn-primary transition border-0 lh-1 fw-medium text-black"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour ")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Date de commande :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.format_Date(_ctx.vente?.dateCommande)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Reference :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.vente?.refCom), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Type de commande :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.vente?.typeCommande || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Type de facture :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.vente?.typeFacture || 'N/A'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Taux AIB :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.vente?.tauxAIB || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Montant reçu :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.separateur(_ctx.vente?.montantReçu || '-' )), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Client :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.vente?.client?.nomClient ? `${_ctx.vente?.client?.nomClient} ${_ctx.vente?.client?.prenomClient || ''}` : _ctx.vente?.client?.raisonSociale || 'N/A'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Produits vendus", -1)),
            _createElementVNode("table", _hoisted_16, [
              _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Produit"),
                  _createElementVNode("th", null, "Quantité"),
                  _createElementVNode("th", null, "P.UNIT"),
                  _createElementVNode("th", null, "P.HT"),
                  _createElementVNode("th", null, "M.HT"),
                  _createElementVNode("th", null, "ts"),
                  _createElementVNode("th", null, "TR"),
                  _createElementVNode("th", null, "VA"),
                  _createElementVNode("th", null, "MR"),
                  _createElementVNode("th", null, "M.HTAR"),
                  _createElementVNode("th", null, "M.TVA"),
                  _createElementVNode("th", null, "M.TTC")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vente?.proCondiCommandeClients, (produit, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(produit?.libelleProduit|| '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(produit?.qtite || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(produit?.prixTtc || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(produit?.prixHt || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.separateur(produit?.montantHt || '-' )), 1),
                    _createElementVNode("td", null, _toDisplayString(produit?.taxeSpecifique || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(produit?.typeRemise || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(produit?.valeurRemise || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(produit?.remise || '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.separateur(produit?.montantHtApresRemise || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.separateur(produit?.montantTva || '-')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.separateur(produit?.montantTtc || '-')), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}